<nav class="toc" [attr.aria-label]="copy.tocLabel">
  <!-- Banner toggle (solo visible en mobile) -->
  <button class="toc__mobile-toggle" type="button"
    [attr.aria-expanded]="isTocExpanded()"
    (click)="toggleToc()">
    <span class="toc__mobile-toggle-label">{{ copy.tocHeading }}</span>
    <app-icon [icon]="chevronIcon" [size]="16" color="currentColor"
      [class.toc__chevron--open]="isTocExpanded()" />
  </button>

  <!-- Contenido del TOC (siempre visible en desktop, colapsable en mobile) -->
  <div class="toc__content" [class.toc__content--expanded]="isTocExpanded()">
    @if (gameLogo) {
      <img
        class="toc__game-logo"
        [src]="gameLogo"
        [alt]="game().name"
        loading="lazy"
      />
    }

    <h3 class="toc__heading">{{ copy.tocHeading }}</h3>

    <ul class="toc__list">
      @for (section of sections(); track section.id) {
        <li>
          <button
            class="toc__link"
            [class.toc__link--active]="activeSection() === section.id"
            [style.--toc-accent]="game().accentColor"
            (click)="onSectionClick(section.id); isTocExpanded.set(false)"
            type="button"
          >
            {{ section.heading }}
          </button>
        </li>
      }
    </ul>

    <hr class="toc__divider" />

    <span class="toc__share-label">{{ copy.share }}</span>
    <div class="toc__share-buttons">
      <button
        class="toc__share-btn"
        type="button"
        [attr.aria-label]="copy.shareTwitter"
        (click)="shareTwitter()"
      >𝕏</button>
      <button
        class="toc__share-btn"
        type="button"
        [attr.aria-label]="copy.shareFacebook"
        (click)="shareFacebook()"
      >f</button>
      <button
        class="toc__share-btn"
        type="button"
        [attr.aria-label]="copy.shareWhatsApp"
        (click)="shareWhatsApp()"
      >WA</button>
      <button
        class="toc__share-btn"
        type="button"
        [attr.aria-label]="copied() ? copy.urlCopied : copy.copyUrl"
        (click)="copyUrl()"
      >
        {{ copied() ? '✓' : '🔗' }}
      </button>
    </div>
  </div>
</nav>
